










import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Cell extends Vue {
  @Prop({ type: String, default: 'center' }) align!: string;
  @Prop(Boolean) padded!: boolean;
  @Prop(Boolean) noWrap!: boolean;

  $refs!: {
    header: HTMLDivElement;
  }

  stickied = false;
  observer!: IntersectionObserver;

  mounted() {
    this.observer = new IntersectionObserver(this.toggleSticky, {
      rootMargin: '-61px 0px 0px 0px',
      threshold: 1,
    });

    this.observer.observe(this.$refs.header);
  }

  unmount() {
    this.observer.unobserve(this.$refs.header);
  }

  toggleSticky([e]: IntersectionObserverEntry[]) {
    this.stickied = e.intersectionRatio < 1 && e.intersectionRatio > 0.2;
  }
}
